import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpTestService } from '../../services/http.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  oldPass:any
  newPass:any
  confirmNewPass:any
  errorMsg:any = null
  successMsg:any = null
  token:any
  disableSubmit:boolean = true
  public showPatternPwd:boolean = false ;
  public patternPwd : string ="";
  //acceptOrRejectionForm: FormGroup;
  //passPattern = "^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$"
  //submitted:boolean = false;

  constructor(private route: ActivatedRoute,public http: HttpTestService,private router: Router,public formBuilder: FormBuilder) {
    //this.token = route.snapshot.paramMap.get('token');
    //this.consumerData = this.route.snapshot.params['consumerData'];
    this.route.queryParams.subscribe(params => {
      if (params.token && params.hasOwnProperty('token')) { this.token = params.token; }
    });
  }

  ngOnInit() {
    // this.acceptOrRejectionForm = this.formBuilder.group({
    //   password: ['', [Validators.required, Validators.pattern(this.passPattern)]],
    //   confirmPassword: ['', [Validators.required, Validators.pattern(this.passPattern)]],
    // });
  }

  //get f() { return this.acceptOrRejectionForm.controls; }

  checkPassword(){
    if(!this.newPass || this.newPass.trim().toLowerCase() == '' || this.newPass == null || this.newPass == undefined || !this.confirmNewPass || this.confirmNewPass == null || this.confirmNewPass == undefined || this.confirmNewPass.trim().toLowerCase() == ''){
      this.disableSubmit = true
      this.errorMsg = 'Invalid input'
    }
    else if(this.newPass != this.confirmNewPass){
      this.errorMsg = 'Password and confirm password does not match!'
      this.disableSubmit = true
    }
    else if(this.newPass == this.confirmNewPass){
      this.disableSubmit = false
      this.errorMsg = null
    }
  }
  validateNewPassword(){
    //this.showPatternPwd = true ;
    this.patternPwd = "Password should be at least 8 characters but less than 20 characters with at least one number, one alphabet, one special character(i.e. ?=.*[!@#$%^&] ) and one uppercase ALPHABET!";
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    if(this.newPass.indexOf("/") !== -1) this.newPass = "";
    if(strongRegex.test(this.newPass)) {
      this.showPatternPwd = false ;
    } else { this.showPatternPwd = true ;}
  }

  submit(){
        let param = {
            password : this.newPass,
            confirmPassword : this.confirmNewPass
        }
      
        this.http.resetPassword(param,this.token).subscribe(
            (data: any) => {
              if(data == 'Invalid')
              this.errorMsg = 'Sorry, could not find valid password reset link!';
              else if(data == 'Expired')
              this.errorMsg = 'Your password reset link has expired, please request new password reset link';
              else if(data == 'Success'){
                this.successMsg = 'Your password has been reset successfully!';
                setTimeout(() => { this.router.navigate(['login'],{ skipLocationChange: true }); }, 5000);
              }
              else
              this.errorMsg = data;
              
            },
            (error) => {
              this.errorMsg = error;
        });
  }
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/change-password/change-password.component.ts